import {ElementRef, Injectable} from '@angular/core';
import {AppConfigService} from './config.service';

const EVENT_TYPE = 'contextmenu';

@Injectable()
export class ContextMenuService {

    constructor(
        private appConfigService: AppConfigService
    ) {}

    public disableContextMenu(elementRef: ElementRef): () => void {
        let eventListener: any;

        if (this.appConfigService.appConfig.disableContextMenu) {
            eventListener = (event: MouseEvent) => event.preventDefault();
            elementRef.nativeElement.addEventListener(EVENT_TYPE, eventListener);
        }

        return () => {
            if (eventListener) {
                elementRef.nativeElement.removeEventListener(EVENT_TYPE, eventListener);
            }
        };
    }
}
